import React from 'react';
import LeftContent from './LeftContent/LeftContent';
import RightContent from './RightContent/RightContent';
import * as S from './styles';

function Main() {
  return (
    <S.Main>
      <S.FeatureAnsiedade>
        <S.FeatureTitle>Reduza sua ansiedade</S.FeatureTitle>
        <S.FeatureRelacionamentos>
          <S.FeatureTitle>Melhore seus relacionamentos</S.FeatureTitle>
          <S.FeatureLideranca>
            <S.FeatureTitle>Melhore sua liderança e potencial</S.FeatureTitle>
            <S.MainContent>
              <LeftContent />
              <RightContent />
            </S.MainContent>
          </S.FeatureLideranca>
        </S.FeatureRelacionamentos>
      </S.FeatureAnsiedade>
    </S.Main>
  );
}

export default Main;
